export const NAMESPACE = 'COMMUNITIES_FILTER/LAST_POST/';

export const SET_SOURCE = NAMESPACE + 'SET_SOURCE';
export const SET_ONLY_FROM_COMMUNITY = NAMESPACE + 'SET_ONLY_FROM_COMMUNITY';
export const SET_START_DATE = NAMESPACE + 'SET_START_DATE';
export const SET_END_DATE = NAMESPACE + 'SET_END_DATE';
